import { createStore as reduxCreateStore } from "redux"
import * as ActionType from './actionTypes';
import quiz from '../data/quiz';

const initialState = {
  quiz,
  page: '',
  selected: {},
  scrollPosition: 0,
  menu: false,
  mobileMore: false,
  config: {
    siteUrl: 'https://giftmatcher.urbandaddy.com/'
  }
}

function setDevtools() {
  if (process.env.NODE_ENV === 'development' && typeof window === 'object') {
    return window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
  }
}

const reducer = (state, action) => {
  if (action.type === ActionType.SET_MENU) {
    return Object.assign({}, state, {
      menu: action.menu
    })
  }

  if (action.type === ActionType.SET_PAGE) {
    return Object.assign({}, state, {
      page: action.page
    })
  }

  if (action.type === ActionType.SET_SCROLL_POSITION) {
    return Object.assign({}, state, {
      scrollPosition: action.scrollPosition
    })
  }

  if (action.type === ActionType.SET_ANSWER) {
    return Object.assign({}, state, {
      selected: {
        ...state.selected,
        [action.key]: action.answer
      }
    })
  }

  if (action.type === ActionType.RESET) {
    return initialState;
  }

  if (action.type === ActionType.SHOW_MORE) {
    return Object.assign({}, state, {
      mobileMore: action.mobileMore
    })
  }

  return state
}

const createStore = () => reduxCreateStore(reducer, initialState, setDevtools())
export default createStore
